import React, { memo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Logo.module.scss';

const Logo = ({ size, url, altText }) => {
  const classes = classnames(styles.logo, [styles[size]]);
  return <img className={classes} src={url} alt={altText} />;
};

Logo.propTypes = {
  url: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'full-width',
    'companyswitcher'
  ])
};

Logo.defaultProps = {
  size: 'full-width'
};

export default memo(Logo);
